import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams, BaseRequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { AuthRequestBnbaccess } from './auth-request-bnbaccess.model';
import { DateUtils } from 'ng-jhipster';
@Injectable()
export class AuthRequestBnbaccessService {

    private resourceUrl = 'api/auth-requests';

    constructor(private http: Http, private dateUtils: DateUtils) { }

    create(authRequest: AuthRequestBnbaccess): Observable<AuthRequestBnbaccess> {
        let copy: AuthRequestBnbaccess = Object.assign({}, authRequest);
        copy.tokenExpiration = this.dateUtils
            .toDate(authRequest.tokenExpiration);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(authRequest: AuthRequestBnbaccess): Observable<AuthRequestBnbaccess> {
        let copy: AuthRequestBnbaccess = Object.assign({}, authRequest);
        copy.tokenExpiration = this.dateUtils
            .toDate(authRequest.tokenExpiration);
        return this.http.put(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    find(id: number): Observable<AuthRequestBnbaccess> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            let jsonResponse = res.json();
            jsonResponse.tokenExpiration = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.tokenExpiration);
            return jsonResponse;
        });
    }

    query(req?: any): Observable<Response> {
        let options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }


    private convertResponse(res: any): any {
        let jsonResponse = res.json();
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].tokenExpiration = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].tokenExpiration);
        }
        res._body = jsonResponse;
        return res;
    }

    private createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/auth-request/auth-request-bnbaccess.service.ts